<template>
    <div class="" v-if="node && node.share">
        <a href="#" class="me-2" @click.prevent="copyClipboard(node.share.show)">
            <i class="fas fa-clipboard fa-2x"></i>
        </a>
        <a :href="node.share.line" target="_blank">
            <i class="fab fa-line fa-2x ms-3"></i>
        </a>
        <a :href="node.share.twitter" target="_blank">
            <i class="fab fa-x-twitter fa-2x ms-3"></i>
        </a>
        <a :href="node.share.facebook" target="_blank">
            <i class="fab fa-facebook fa-2x ms-3"></i>
        </a>
        <a @click.prevent="showQrModal">
            <i class="fas fa-qrcode fa-2x ms-3"></i>
        </a>
    </div>
    <div class="spinner" v-else>
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
    <div id="clipboard" aria-hidden="true"></div>

    <div class="modal fade" tabindex="-1" role="dialog" id="qr_modal">
        <div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">QRコードのダウンロード</h5>
                    <button type="button" class="btn-close" data-mdb-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body text-center" v-if="node && node.share">
                    <form id="download_qr_form" action="/admin/qr-image">
                        <div class="d-flex justify-content-center">
                            <img :src="qr_url" class="w-75" />
                        </div>
                        <div class="row mb-3 px-2 text-start">
                            <label class="col-3 pt-2">色</label>
                            <select class="qr_color form-control col-9" name="qr_color" v-model="qr_color">
                                <option value="184,28,34">赤</option>
                                <option value="96,59,148">紫</option>
                                <option value="52,120,56">緑</option>
                                <option value="0,0,0">黒</option>
                                <option value="72,97,151">青</option>
                                <option value="255,69,0">オレンジ</option>
                            </select>

                            <label class="col-3 pt-2">大きさ</label>
                            <select class="size form-control col-9" name="size" v-model="size">
                                <option value="" disabled>画面用</option>
                                <option value="px:450">標準：450ピクセル</option>
                                <option value="px:305">小：200ピクセル</option>
                                <option value="" disabled>印刷用 350dpi</option>
                                <option value="dpi:350,mm:15">15mm：207ピクセル</option>
                                <option value="dpi:350,mm:20">20mm：276ピクセル</option>
                                <option value="dpi:350,mm:25">25mm：344ピクセル</option>
                                <option value="dpi:350,mm:30">30mm：413ピクセル</option>
                                <option value="dpi:350,mm:35">35mm：482ピクセル</option>
                                <option value="dpi:350,mm:40">40mm：551ピクセル</option>
                                <option value="dpi:350,mm:45">45mm：620ピクセル</option>
                                <option value="dpi:350,mm:50">50mm：689ピクセル</option>
                                <option value="" disabled>印刷用 600dpi</option>
                                <option value="dpi:600,mm:15">15mm：354ピクセル</option>
                                <option value="dpi:600,mm:20">20mm：472ピクセル</option>
                                <option value="dpi:600,mm:25">25mm：591ピクセル</option>
                                <option value="dpi:600,mm:30">30mm：709ピクセル</option>
                                <option value="dpi:600,mm:35">35mm：827ピクセル</option>
                                <option value="dpi:600,mm:40">40mm：945ピクセル</option>
                                <option value="dpi:600,mm:45">45mm：1063ピクセル</option>
                                <option value="dpi:600,mm:50">50mm：1181ピクセル</option>
                                <option value="" disabled>デザインソフト用</option>
                                <option value="dpi:600,mm:20,svg:1">SVG</option>
                            </select>
                            <template v-if="node.node_type == 10">
                                <input type="hidden" name="qr_type" value="normal" />
                            </template>
                            <template v-else>
                                <label class="col-3 pt-2">種類</label>
                                <select class="size form-control col-9" name="qr_type" v-model="qr_type">
                                    <option value="normal">QRコード</option>
                                    <option value="memory">記録用QRコード</option>
                                </select>
                            </template>
                        </div>
                        <input type="hidden" name="node_key" :value="node.node_key" />
                    </form>
                </div>

                <div class="modal-footer">
                    <a class="btn btn-primary me-2" :href="qr_download_url">ダウンロード</a>
                    <a href="#" class="btn btn-default" data-mdb-dismiss="modal">閉じる</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Modal } from 'mdb-ui-kit';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import utils from '@js/modules/utils/utils';
import Request from '@js/modules/utils/request';

var qr_modal;

export default defineComponent({
    name: 'ShareButtons',
    props: {
        node: {
            type: Object,
            default: null,
        },
        ccode: {
            type: String,
            default: '',
        },
        sub_code: {
            type: String,
            default: '',
        },
    },
    data: () => {
        return {
            qr_type: 'normal',
            qr_color: '0,0,0',
            size: 'px:450',
        };
    },
    watch: {
        node: {
            handler(newValue, oldValue) {
                if (!newValue) {
                    return;
                } else if (newValue.share) {
                    return;
                }

                Request.get('/api/get-share-links', {
                    node_id: newValue.id,
                    ccode: this.ccode,
                    sub_code: this.sub_code,
                })
                    .then(res => {
                        newValue.share = res.data;
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            immediate: true,
        },
    },
    computed: {
        qr_url() {
            if (this.node.node_key) {
                const params = {
                    node_key: this.node.node_key,
                    type: this.qr_type,
                    color: this.qr_color,
                    px: '300',
                };
                return (
                    '/admin/qr-image?' +
                    Object.entries(params)
                        .map(e => `${e[0]}=${e[1]}`)
                        .join('&')
                );
            } else {
                return '';
            }
        },
        qr_download_url() {
            if (this.node.node_key) {
                const params = {
                    node_key: this.node.node_key,
                    type: this.qr_type,
                    color: this.qr_color,
                };

                const list = this.size.split(',');
                list.forEach(item => {
                    const item_arr = item.split(':');
                    if (item_arr.length == 2) {
                        params[item_arr[0]] = item_arr[1];
                    }
                });

                return (
                    '/admin/qr-image?' +
                    Object.entries(params)
                        .map(e => `${e[0]}=${e[1]}`)
                        .join('&')
                );
            } else {
                return '';
            }
        },
        download_filename() {
            if (this.node.name) {
                return 'QR_' + this.node.name + '_KakehashiMemory.png';
            } else {
                return 'QR_KakehashiMemory.png';
            }
        },
    },
    methods: {
        copyClipboard(str) {
            utils.copyClipboard(str, '#clipboard');
            Swal.fire({
                text: 'URLをクリップボードにコピーしました。',
            });
        },
        showQrModal() {
            if (!qr_modal) {
                const mdl = document.getElementById('qr_modal');
                qr_modal = new Modal(mdl);
            }
            qr_modal.show();
        },
    },
});
</script>

<style scoped>
.spinner {
    margin: 1rem auto;
    width: 70px;
    text-align: center;
}

.spinner > div {
    width: 18px;
    height: 18px;
    background-color: var(--text-default-500);

    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
}

.spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
        -webkit-transform: scale(0);
    }
    40% {
        -webkit-transform: scale(1);
    }
}

@keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    40% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}
</style>
